import cx from 'clsx'
import React, { AnchorHTMLAttributes, DetailedHTMLProps, FC } from 'react'

import cn from '../styles.module.scss'

export interface ILinkProps
  extends DetailedHTMLProps<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  color?: 'black' | 'white' | 'gradient'
  weight?: 'normal' | 'medium' | 'bold'
  opacity?: number
  size?: 'h1' | 'h2' | 'h3' | 'big' | 'small'
  decoration?: 'normal' | 'underline'
}

const Link: FC<ILinkProps> = ({
  color = 'black',
  weight = 'normal',
  opacity = 1,
  size = 'big',
  decoration = 'underline',
  style,
  className,
  children,
  ...rest
}) => {
  const classes = cx(
    cn[size],
    cn[weight],
    cn[color],
    {
      [cn.underline]: decoration === 'underline',
    },
    className,
  )
  return (
    <a {...rest} className={classes} style={{ opacity, ...style }}>
      {children}
    </a>
  )
}

export default Link
